module.exports = __webpack_public_path__ + "img/mochi.8182f343.png";